import styled from '@emotion/styled';
import { PersonOffOutlined as NoAccountIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

const MessageWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '.MuiSvgIcon-root': {
    marginRight: 12,
  },
  p: {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 15,
  },
});

type NoAccountConnectedMessageProps = {
  variant: 'microsoft' | 'google';
};

const NoAccountConnectedMessage = ({
  variant,
}: NoAccountConnectedMessageProps) => (
  <MessageWrapper>
    <NoAccountIcon />
    <p>
      <FormattedMessage
        id={`portfolio.challenge.files.add.connected_accounts_dialog.account_settings.not_connected_message.${variant}`}
      />
    </p>
  </MessageWrapper>
);

export default NoAccountConnectedMessage;
